import { Kitchen } from '@rta/rta-blueprint-library';
import { Font, Text, View } from '@react-pdf/renderer';

import { fontConfig } from '../font-config';
import { styleSheet } from '../style-sheet';

Font.register(fontConfig);

export type EstimateDocumentHeaderProps = {
	data: {
		customer: any;
		project: any;
		kitchen: Kitchen;
	};
}
// Create Document Component
export const EstimateDocumentHeader = (data: EstimateDocumentHeaderProps) => {
	const { customer, project, kitchen } = data.data;

	const date = new Date();
	const dateString = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

	return (
		<View style={styleSheet.header}>
			<View style={styleSheet.headerThreeColumns}>
				{/* Left Column */}
				<View style={styleSheet.headerLeftColumn}>
					<View style={styleSheet.block}>
						<Text style={[styleSheet.heading, styleSheet.marginBottom]}>{customer?.firstName} {customer?.lastName}</Text>
						<Text style={styleSheet.text}>{customer?.email}</Text>
						<Text style={styleSheet.text}>{customer?.phone}</Text>
					</View>
					<View style={styleSheet.marginTop}>
						<Text style={styleSheet.text}>Reference: {new Date().toISOString()
							.slice(0, 10)
							.replace(/-/u, '')}-{Math.floor(Math.random() * 1000000000)}</Text>
						<Text style={styleSheet.text}>Quote created: {dateString}</Text>
					</View>
				</View>

				{/* Center Column */}
				<View style={styleSheet.headerCenterColumn}>
					<Text style={[styleSheet.heading, styleSheet.marginBottom]}></Text>
				</View>

				{/* Right Column */}
				<View style={styleSheet.headerRightColumn}>
					<Text style={[styleSheet.heading, styleSheet.marginBottom]}>RTA Outdoor Living, LLC</Text>
					<Text style={styleSheet.text}>1 Bayside Rd, Suite 107 Greenland</Text>
					<Text style={styleSheet.text}>New Hampshire 03840</Text>
					<Text style={styleSheet.text}>1 (800) 827-1830</Text>
					<Text style={styleSheet.text}>www.rtaoutdoorliving.com</Text>
					<View style={styleSheet.marginTop}>
						<Text style={styleSheet.heading}>Prepared by: {project[0].designer?.firstName} {project[0].designer?.lastName}</Text>
						<Text style={styleSheet.text}>{project[0].designer?.email}</Text>
					</View>
				</View>
			</View>
		</View>
	);
};
